import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectConstants } from 'src/app/project-constants';
import { ProviderModel } from 'src/models/ProviderModel';
import { urls } from 'src/services/api/urls';
import { GeneralServicesImplService } from 'src/services/general-services-impl.service';
import * as servers from '../../../../services/api/servers';

@Injectable({
    providedIn: 'root'
  })

export class BillingConsuntivoService extends GeneralServicesImplService{
    constructor(http: HttpClient){
        super(http);
    }

    baseUrl: string = servers.apiUrl + urls.billingController;
    baseUrlGrouped: string = servers.apiUrl + urls.deltaVolumiGrouped;

    getPage(filters: any, payload?: any): Observable<any> {
        const url = this.baseUrl + this.LINKS.GETPAGE;
        const body =  payload ? JSON.stringify(payload) : null;
        const header = ProjectConstants.returnGeneralHeader();
        return this.http.post( url, body, {headers: header, responseType: 'json', params: filters})
          .pipe(
            // map (data => data) da inserire gestione errori
          );
      }

      getNameGenerateXlsx(offset, payload: any, comparing: boolean, isGrouped: boolean) {
        let url = this.baseUrl;
        if (comparing) {
          url = url + this.LINKS.GENERATE_COMPARISON_XLSX;
        } else {
          url = url + this.LINKS.GENERATE_XLSX;
        }
        let param: HttpParams = new HttpParams();
        param = param.set('isGrouped', isGrouped.toString());     
        const body =  payload ? JSON.stringify(payload) : null;
        const header = ProjectConstants.returnGeneralHeader();
    
        return this.http.post( url, body, {headers: header, responseType: 'blob', params: param})
          .pipe(
            // map (data => data) da inserire gestione errori
          );
    
      }

      private generateUrl(provider: ProviderModel, selectedUrl: string) {
        let currBaseUrl =  this.baseUrl;
        if (provider && provider.cod && provider.cod === 'DXC') {
          currBaseUrl = this.baseUrlGrouped;
        }
        return currBaseUrl + selectedUrl;
      }

      updateAllClaims(offset: any, provider: ProviderModel): Observable<any> {
        // const url = this.generateUrl(provider, this.LINKS.UPDATE_ALL_CLAIMS);
        const url = this.baseUrl + this.LINKS.UPDATE_ALL_CLAIMS
        const body =  offset ? JSON.stringify(offset) : null;
        const header = ProjectConstants.returnGeneralHeader();
        return this.http.post( url, body, {headers: header, responseType: 'json'})
          .pipe(
            // map (data => data) da inserire gestione errori
          );
      }
}